import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

export const INPUT_WIDE_WIDTH = 300;
export const INPUT_NARROW_WIDTH = 70;
export const INPUT_LABEL_WIDTH = 140;
export const ATTENTION_COLOR = '#c41723';
export const NORMAL_TEXT_COLOR = TabStyles.Typography.Color.Primary;
export const NORMAL_FONT_SIZE = 12;
export const VPC_FONT_XLARGE = 15;
export const VPC_BOLD_FONT_WEIGHT = 700;
export const CHECKBOX_SIZE = 15;

export const groupNameMessage = style({
  paddingLeft: 10,
  fontSize: NORMAL_FONT_SIZE,
  color: NORMAL_TEXT_COLOR,
});

export const ellipsisStyle: NestedCSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

export const wideWidth: NestedCSSProperties = {
  width: INPUT_WIDE_WIDTH
};

export const narrowTextFieldStyle = style({
  '$nest': {
    'input': {
      width: INPUT_NARROW_WIDTH
    }
  }
});

export const formError = style({
  color: ATTENTION_COLOR
});

export const disabledText = style({
  color: TabStyles.Typography.Color.Disabled
});

export const settingsRadioButtonItemHeight = style({
  '$nest': {
    '& > label': {
      marginLeft: 0
    },
    '& > label + label': {
      marginTop: 3 * TabStyles.Spacing.SmallSpace
    }
  }
});

export const settingsRadioButtonLastItemIndent = style({
  '$nest': {
    '& > label:last-child': {
      marginLeft: TabStyles.Spacing.LargeSpace
    }
  }
});

export const learnMoreStyle = style({
  paddingLeft: 2 * TabStyles.Spacing.SmallSpace,
  paddingRight: 2 * TabStyles.Spacing.SmallSpace,
});

export const dropdownListStyle = style({
  maxHeight: '310px',
});

export namespace SettingsStyles {

  export const checkboxMessageIndent = style({
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace
  });

  export const checkboxGroup = style({
    $nest: {
      '& > *': {
        minHeight: '23px',
        marginBottom: TabStyles.Spacing.DefaultSpace,
      }
    }
  });

  export const settingsGroup = style({
    paddingBottom: TabStyles.Spacing.LargeSpace
  });

 // so it can be reused on classes that extend this.
  export const settingsGroupNameProperties: NestedCSSProperties = {
    fontSize: VPC_FONT_XLARGE,
    fontWeight: VPC_BOLD_FONT_WEIGHT,
    paddingBottom: TabStyles.Spacing.MediumSpace,
    color: TabStyles.Typography.Color.PrimaryDark
  };

  export const settingsGroupName = style({
    ...settingsGroupNameProperties
  });

  export const settingsGroupDescription = style({
    paddingBottom: TabStyles.Spacing.MediumSpace
  });

  export const indent = style({
    paddingLeft: TabStyles.Spacing.LargeSpace
  });

  export const settingsSubGroup = style({
    paddingLeft: TabStyles.Spacing.LargeSpace
  });
}

/**
 * Styles for label + textbox forms.
 */
export namespace SettingsTableStyles {
  export const inputLabelCell = style({
    verticalAlign: 'top',
    paddingTop: TabStyles.Spacing.SmallSpace,
    paddingRight: '35px'  // No TabStyles equivalent
  });

  export const inputControlCell = style({
    minWidth: '250px'
  });
}

export const warningText = style({
  color: ATTENTION_COLOR,
  marginTop: TabStyles.Spacing.SmallSpace,
  marginLeft: TabStyles.Spacing.DefaultSpace + CHECKBOX_SIZE,
});

export const subspaceStyle = style({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
});

export const timestampStyle = style({
  paddingLeft: TabStyles.Spacing.SmallSpace,
  paddingRight: TabStyles.Spacing.SmallSpace,
});

export const viewActivityLinkContainer = style({
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace
});

export const actionButtonContainer = style({
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.LargeSpace
});
